import * as React from 'react';
// tslint:disable-next-line: import-name
import Dropzone from 'react-dropzone';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import * as MimeTypeConstants from '../constants/MimeTypeConstants';
import AssetsManager from '../utils/AssetsManager';
import {FileUploaderProps} from '../types/components';

const thumbnailPdf = '/assets/images/common/pdf-icon-normal.svg';

class FileUploader extends React.Component<FileUploaderProps, {}> {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        required: false,
        hasError: false
    };

    validateEmpty = (accepted, rejected) =>
        this.props.required && (rejected.length > 0 || accepted.length === 0) ?
            ValidateConstant.ERROR_REQUIRED : null

    onDrop = (accepted, rejected) => {
        const error = this.validateEmpty(accepted, rejected);
        this.props.onDrop(accepted, this.props.type, this.props.section, error);
    }

    render() {
        const {id, hasError, labelError, customClass, uploadedFiles, multiple, label, hideDelete, accept,
            required} = this.props;
        const mimeTypeAccept = accept || MimeTypeConstants.DZ_IMAGE_FILE_UPLOADER_ACCEPTED_TYPES;
        return (
            <React.Fragment>
                <div className={`file-uploader-wrapper ${customClass ? customClass : ''}`}>
                    {(multiple || uploadedFiles && uploadedFiles.length === 0) && <Dropzone
                        multiple={multiple}
                        accept={mimeTypeAccept}
                        onDrop={this.onDrop}>
                        {({ getRootProps, getInputProps }) => (
                            <div className="drop-zone-box m-1" {...getRootProps()}>
                            <div className={`file-uploader-box ${required && hasError && labelError ? 'is-invalid' : ''}`}>
                                <input {...getInputProps()} />
                                <div className="button-small-enabled drop-zone-label">{label.toUpperCase()}</div>
                                <div className="add-new-file">
                                    <img src={AssetsManager('/assets/images/common/add-new-icon.svg')} />
                                </div>
                            </div>
                            </div>
                        )}
                    </Dropzone>}
                    {uploadedFiles && uploadedFiles.map((item, index) => {
                        const isPdf = item.mimeType === MimeTypeConstants.PDF_MIME_TYPE;
                        return <div className="file-thumbnail m-1" key={index}>
                            <div className="thumbnail">
                                <img className={isPdf ? 'icon' : ''} src={isPdf ? thumbnailPdf : item.thumbnailUrl}/>
                            </div>
                            <div className="check-file">
                                <img src={AssetsManager('/assets/images/common/check-icon.svg')}/>
                            </div>
                            {!hideDelete && <div className="remove-file">
                                <button onClick={() => this.props.onDelete && this.props.onDelete(item.id, this.props.type)}
                                        className="btn-link remove-file-button">
                                    <img src={AssetsManager('/assets/images/common/remove-icon.svg')}/>
                                </button>
                            </div>}

                            <div className="info-file">
                                <button onClick={() => this.props.onClickThumbnail(item)}
                                        className="btn-link remove-file-button btn-link-image text-truncate">
                                    <span className="filename">{item.fileName}</span>
                                </button>
                            </div>
                        </div>;
                    })}
                    {required && hasError && labelError && <div className="w-100">
                        <strong id={`${id}Help`} className={'form-text is-invalid'}>{labelError}</strong>
                    </div>}
                </div>
            </React.Fragment>
        );
    }
}

export default FileUploader;
